<template>
    <div class="my-account-container">
        <sidebar
            :sidebar-dashboard="true"
            class="my-account-container__sidebar"
        ></sidebar>
        <sidebar-mobile
            class="my-account-container__sidebar-mobile"
        ></sidebar-mobile>
        <creator-name class="my-account-container__creator-name"></creator-name>
        <creator class="my-account-container__creator"></creator>
        <personal-details
            class="my-account-container__personal-details"
        ></personal-details>
    </div>
</template>

<script>
import Sidebar from '@/components/sidebar/index';
import SidebarMobile from '@/components/sidebar_mobile/index';
import CreatorName from '@/components/dashboard/sections/DashboardCreatorName';
import Creator from '@/components/my_account/sections/Creator';
import PersonalDetails from '@/components/my_account/sections/PersonalDetails';

export default {
    name: 'MyAccount',
    components: {
        Sidebar,
        SidebarMobile,
        CreatorName,
        Creator,
        PersonalDetails,
    },
};
</script>

<style scoped lang="scss">
.my-account-container {
    @include main-grid-container;

    &__sidebar {
        grid-column: col-start / span 3;
        grid-row: auto;
        height: 100%;
    }
    &__sidebar-mobile {
        grid-column: col-start / span 13;
        grid-row: auto;
    }
    &__creator-name {
        grid-column: col-start 4 / 13;
        grid-row: 1;
        @media (max-width: $sm-up) {
            grid-column: col-start / 13;
            margin-top: 3rem;
        }
    }
    &__creator {
        grid-column: col-start 4 / 13;
        grid-row: 2;
        margin-top: -796px;
        background: $white-main;
        height: $smallest-height;
        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin-top: 2rem;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-row: auto;
        }
    }
    &__personal-details {
        grid-column: col-start 4 / 12;
        grid-row: 3;
        margin-top: -520px;
        background: $white-main;
        height: $very-small-height;

        @media (min-width: 1201px) and (max-width: 1360px) {
            grid-column: col-start 4 / 13;
        }
        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin-top: 0;
            height: $small-height;
        }

        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-row: auto;
            height: 740px;
        }
    }
}
</style>
